module.exports = __webpack_public_path__ + "img/emerald_dragon_small.431b92da.png";